import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import './plugins/vant.js'
import '@vant/touch-emulator'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import scroll from 'vue-seamless-scroll'

// Vue.use(ElementUI)
// 全局配置 ElementUI
Vue.use(ElementUI, {
  size: 'small',
  // 配置 message 全局样式
  message: {
    customClass: 'global-center-message'
  }
})
Vue.use(scroll)


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
